import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function CTABanner() {
  return (
    <section className="bg-[#4B7055] text-white relative overflow-hidden" data-testid="cta-banner">
      <div className="container-x py-16 lg:py-20 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
        <div className="lg:col-span-8">
          <p className="text-overline text-white/70 mb-3">Engage Street Society</p>
          <h2 className="heading-section text-3xl sm:text-4xl lg:text-5xl">
            Ready to discuss a scope, set-aside, or teaming opportunity?
          </h2>
          <p className="mt-4 text-white/85 max-w-xl">
            Connect with our team for capability statements, past performance discussions, or upcoming
            procurement coordination.
          </p>
        </div>
        <div className="lg:col-span-4 flex flex-col sm:flex-row lg:flex-col gap-3 lg:items-end">
          <Link to="/contact" className="btn-base bg-white text-[#0A1F35] hover:bg-[#0A1F35] hover:text-white" data-testid="cta-banner-contact">
            Contact Us <ArrowRight size={16} />
          </Link>
          <Link to="/capabilities" className="btn-base btn-outline-light" data-testid="cta-banner-capabilities">
            View Capabilities
          </Link>
        </div>
      </div>
    </section>
  );
}
